<!DOCTYPE html>
<template>
<div class="dash"
     v-if="userData">

  <div class="sidemenu">
    <div>
      <div class="uppercaseheader">My projects</div>
      <b-list-group>
        <b-list-group-item v-for="project in projects"
                           :key="project.id"
                           :active="project.id == projectId"
                           @click="changeProject(project.id)"
                           button>{{project.name}}
        </b-list-group-item>
      </b-list-group>
    </div>
    <b-button variant="success"
              size="sm"
              @click="addNew()">
      New project
    </b-button>

    <a href="https://connect.stripe.com/express/oauth/authorize?redirect_uri=https://www.getblueteam.com/dashboard&client_id=ca_H2hUR5iif9POmHVGs71gppSUWm3LZCrk&state={STATE_VALUE}"
    target="_blank"><img src="../assets/stripe-blue-on-light.png"
    alt="Connect to Stripe" style="width: 100%; height: 100%;"></a>

  </div>

  <div class="content">

    <template v-if="newProject">
      <OnboardCard type="client"
                   :user="userData"
                   enlarged
                   @close="closeNewProject" />
    </template>
    <template v-else-if="project">
      <MyProjectDetails v-if="!provider"
                        :userData="userData"
                        :project="project"
                        @close="closeProject" />

      <ProviderTable v-if="!provider"
                     :userData="userData"
                     :project="project"
                     @open-provider="openProvider" />

      <ProviderDetails v-if="provider"
                       :userData="userData"
                       :project="project"
                       :provider="provider"
                       @close="closeProvider" />
    </template>
    <template v-else>
      <div class="empty">
        <div>
          <div class="logo large" />
          Create or select a project from the left
        </div>
      </div>
    </template>

  </div>


</div>
</template>

<script>
//Firebase
const firebase = require( '@/firebaseConfig.js' )
const users = firebase.db.collection( 'users' )
//Components
import ProviderDetails from '@/components/client/ProviderDetails.vue'
import ProviderTable from '@/components/client/ProviderTable.vue'
import MyProjectDetails from '@/components/client/MyProjectDetails.vue'
import OnboardCard from '@/components/OnboardCard.vue'
export default {
  name: 'ClientDashboard',
  components: {
    ProviderDetails,
    ProviderTable,
    MyProjectDetails,
    OnboardCard,
  },
  props: {
    user: Object,
    projectId: String,
  },
  data() {
    return {
      userRef: null,
      userData: null,
      projects: [],
      project: null,
      provider: null,
      newProject: false,
    }
  },
  firestore: {
    skills: firebase.db.collection( 'skills' ),
    preferences: firebase.db.collection( 'preferences' ),
  },
  watch: {
    user: {
      // call it upon creation too
      immediate: true,
      handler( user ) {
        if ( user ) {
          this.userRef = users.doc( user.uid )
          this.$bind( 'userData', this.userRef )
          this.$bind( 'projects', firebase.db.collection( 'projects' ).where( 'client', '==', this.userRef ) )
        }
      },
    },
    projectId: {
      // call it upon creation too
      immediate: true,
      handler( projectId ) {
        if ( projectId ) {
          this.$bind( 'project', firebase.db.collection( 'projects' ).doc( projectId ) )
        } else {
          this.project = null
        }
      },
    },
  },
  computed: {
    projectAttributes() {
      return [].concat( this.project.skills )
        .concat( this.project.goals )
        .concat( this.project.preferences )
    }
  },
  methods: {
    changeProject( pid ) {
      this.$router.push( `/dashboard/${pid}` )
    },
    closeNewProject() {
      this.newProject = null
      this.$router.push( '/dashboard' )
    },
    closeProject() {
      this.$router.push( '/dashboard' )
    },
    addNew() {
      this.$router.push( '/dashboard' )
      this.newProject = true
    },
    deleteProject() {
      firebase.db.collection( 'projects' )
        .doc( this.projectId )
        .delete()
        .then( () => {
          this.$router.push( '/dashboard' )
        } )
    },
    openProvider( provider ) {
      this.provider = provider
    },
    closeProvider() {
      this.provider = null
    }
  }
}
</script>


<style scoped lang="scss">
@import "@/styles/global.scss";

.dash {
    display: grid;
    grid-auto-flow: column;
    grid-template-columns: 1fr 5fr;
    grid-column-gap: 1rem;
    min-height: 70vh;
    color: $primary;

    .sidemenu {
        display: grid;
        grid-row-gap: 2rem;
        align-content: flex-start;

        .button {
            justify-content: flex-start;
        }

        .verification {
            display: grid;
            grid-template-columns: auto 1fr;
            align-items: center;
            column-gap: 0.5rem;
            font-size: 0.8rem;

            img {
                width: 2rem;
            }

            .label {
                color: $primary;

                &.verified {
                    color: var(--note);
                }
            }
        }
    }

    .content {
        background: theme-color-level('primary', -12);
        padding: 2rem;
        border-radius: 1rem;
        display: grid;
        grid-row-gap: 2rem;
    }

    .empty {
        display: grid;
        height: 100%;
        align-items: center;
        justify-content: center;
        color: theme-color-level('primary',-8);

        div {
            display: grid;
            grid-row-gap: 1rem;
            justify-items: center;
        }
    }

}
</style>
